import m from "../../geodata/es2015/uaeHigh";
window.am4geodata_uaeHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/uaeHigh.js
// module id = null
// module chunks = 